var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumbs-box"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"mar10",attrs:{"href":"#/index"}},[_vm._v("首页")]),_vm._v(" "),_c('span',{staticClass:"mar10"},[_vm._v(">")]),_c('span',{staticClass:"tips"},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }